import { Modal, Card, Alert, Button } from "antd";
import {
  CloseOutlined,
  ExclamationCircleOutlined,
  CheckCircleOutlined,
} from "@ant-design/icons";

import { TEMPLATE } from "../../../../constants";

import styles from "../common.module.css";
import "../index.css"

const { MODALS } = TEMPLATE.MODAL;

const ModalAssign = (props) => {
  const {
    setmodal,
    isModalOpen,
    setIsModalOpen,
    onClick = () => {},
    data = [],
  } = props;

  const handleOkButton = () => {
    onClick();
    setIsModalOpen();
  };

  const dataError = (setmodal) => {
    if (setmodal === "confirmation_bulk_publish_billing_list") {
      return (data || []).filter((d) => d.status !== 1);
    } else {
      return (data || []).filter((d) => d.status === 4 || d.status === 0);
    }
  };

  const dataWarning = (setmodal) => {
    let dataWarning;

    if(setmodal === "generate_rhb_payment"){
        dataWarning = (data || []).filter((d) => d.status === 3);
    } else if (setmodal === "confirmation_bulk_revert_for_processing_payroll" || 
        setmodal === "confirmation_bulk_mark_as_disbursed_payroll" || 
        setmodal === "confirmation_revert_for_processing_payroll" ) {
        dataWarning = (data || []).filter((d) => d.status === 1);
    }
    return dataWarning;
  }

  const contentFilter = (setmodal, data) => {
    if(setmodal === "generate_rhb_payment"){
        return `You are about to generate a RHB payment file for ${data.length} payroll advance requests.`;
    } else if (setmodal === "confirmation_bulk_revert_for_processing_payroll") {
        return `You are about to revert ${data.length} payroll advance requests as ready for processing.`;
    } else if (setmodal === "confirmation_revert_for_processing_payroll"){
        return `You are about to revert this payroll advance request as ready for processing.`;
    } else if (setmodal === "confirmation_bulk_mark_as_disbursed_payroll"){
        return `You are about to mark ${data.length} payroll advance requests as disbursed.`;
    } else if (setmodal === "confirmation_bulk_publish_billing_list"){
        return `You are about to publish ${data.length} billing to customers.`
    }
  }

  const errorData = dataError(setmodal);
  const warningData = dataWarning(setmodal);
  const showContent = contentFilter(setmodal, data);
  
  const isProceedDisabled =
      (setmodal === "generate_rhb_payment" && (data.length === 0 || data.some((d) => d.status !== 1 && d.status !== 3))) ||
      ((setmodal === "confirmation_bulk_revert_for_processing_payroll" || 
        setmodal === "confirmation_bulk_mark_as_disbursed_payroll"
      ) 
      && (data.length === 0 || data.some((d) => d.status !== 3 && d.status !== 1))) ||
      ( setmodal === "confirmation_revert_for_processing_payroll" && (data.some((d) => d.status !== 3 && d.status !== 1))) ||
      (setmodal === "confirmation_bulk_publish_billing_list" && (data.length === 0 || data.some((d) => d.status !== 1)))

  return (
    <Modal
      open={isModalOpen}
      footer={null}
      onCancel={setIsModalOpen}
      width={400}
    >
      <div
        className={styles["content-container"]}
        style={{ textAlign: "left" }}
      >
        <div style={{ display: "flex", justifyContent: "space-between" }}>
          <Card
            style={{ textAlign: "center", marginBottom: "20px" }}
          >
            <img
              src={MODALS[setmodal]?.img}
              alt="the logo"
              style={{ padding: "7px", width: "50px" }}
            />
          </Card>
          <CloseOutlined
            onClick={setIsModalOpen}
            style={{ marginTop: "-14px" }}
          />
        </div>

        <h3 className={styles["title"]}>{MODALS[setmodal]?.title}</h3>
        <div className={styles.textCard}>
        <span>{showContent}</span>
        {data.length > 0 && (
            <>
              {setmodal === "confirmation_bulk_publish_billing_list" ? (
                errorData.length ? (
                  <Alert
                    type="error"
                    message={`You are unable to proceed due to ${errorData.length} selected billing with unpaid/pending verify/paid status.`}
                    style={{ color: "red", marginTop: "10px" }}
                    icon={<ExclamationCircleOutlined style={{ color: "red" }} />}
                    showIcon={true}
                  />
                ) : (
                  <Alert
                    type="success"
                    message="All of the selected billings are under the correct status for updates."
                    style={{ color: "green", marginTop: "10px" }}
                    icon={<CheckCircleOutlined style={{ color: "green" }} />}
                    showIcon={true}
                  />
                )
              ) : (
                <>
                  {errorData.length ? (
                    <Alert
                      type="error"
                      message={`You are unable to proceed due to ${errorData.length} selected payroll advance requests with disbursed/cancelled status.`}
                      style={{ color: "red", marginTop: "10px" }}
                      icon={<ExclamationCircleOutlined style={{ color: "red" }} />}
                      showIcon={true}
                    />
                  ) : warningData.length ? (
                    <Alert
                      type="warning"
                      message={`There are ${warningData.length} selected payroll advance requests detected with unusual workflow process.`}
                      style={{ color: "#FFA800", marginTop: "10px" }}
                      icon={<ExclamationCircleOutlined style={{ color: "#FFA800" }} />}
                      showIcon={true}
                    />
                  ) : (
                    <Alert
                      type="success"
                      message="All of the selected payroll advance requests are under the correct status for updates."
                      style={{ color: "green", marginTop: "10px" }}
                      icon={<CheckCircleOutlined style={{ color: "green" }} />}
                      showIcon={true}
                    />
                  )}
                </>
              )}
            </>
          )}
        </div>

        <div className={styles["buttons"]}>
          <Button
            onClick={setIsModalOpen}
            className={styles["button"]}
            style={{ borderRadius: "5px", height: "40px" }}
            disabled={isProceedDisabled}
          >
            Cancel
          </Button>
          <Button
            onClick={handleOkButton}
            className={`${styles["button"]} ${styles["active"]}`}
            style={{ borderRadius: "5px", height: "40px" }}
            disabled={isProceedDisabled}
          >
            Proceed
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default ModalAssign;
